export default __webpack_public_path__ + "static/media/IconDesc_LiquidBiofuel.64.a41fcadb.png";